const messages: Record<string, string> = {
	'button.accept': 'Accept',
	'button.addLater': 'Add later',
	'button.changeImage': 'Change the photo',
	'button.continue': 'Continue',
	'button.close': 'Close',
	'button.deleteImage': 'Delete the photo',
	'button.next': 'Next',
	'button.ok': 'Ok',
	'button.prev': 'Back',
	'button.start': 'Next',
	'completeVehicleInformationModal.description': 'Please add the following information:',
	'completeVehicleInformationModal.headline': 'Hint',
	'completeVehicleInformationModal.isRegistrationDocumentUploaded':
		'Photo of the vehicle registration certificate',
	'dataPrivacyModal.headline': 'The terms and conditions',
	'editPhoto.edit': 'Change',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Exemplary photo',
	'landing.dataPrivacyLink': 'By proceeding, you are accepting our terms and conditions.',
	'landing.headline.policyCheck': 'Car inspection on just few steps:',
	'landing.paragraph':
		'Please take 6 photos of the vehicle and a photo of the registration certificate. <br> Remember that the photos are sharp and taken in daylight.',
	'landing.termsAndConditionsLink': 'Accept the terms and conditions',
	'landing.termsAndConditionsLinkDescription':
		'To start, please accept the terms and conditions and click next.',
	'landing.aboutPolicyCheck': 'What is PolicyCheck?',
	'loader.loading': 'Loading data ...',
	'vehicleInformation.headline.first': 'Vehicle details',
	'vehicleInformation.headline.second': 'Photo of the registration certificate (the front)',
	'vehicleInformation.paragraph.first':
		'Take a photo of the vehicle registration certificate (the front)',
	'registrationDocumentExampleModal.headline': 'Photo of the registration certificate - example',
	'vehicleImages.overviewPhotos': 'Vehicle overview photos',
	'vehicleImages.description': 'Please take photos as instructed.',
	'vehicleImages.details.first': 'The front-left of the vehicle',
	'vehicleImages.details.second': 'The rear-left of the vehicle',
	'vehicleImages.details.third': 'The front-right of the vehicle',
	'vehicleImages.details.fourth': 'The rear-right of the vehicle',
	'vehicleInformation.button.next': 'Next »',
	'fourAdditionalPictures.mileage.description':
		'Please take a photo of your mileage. If your vehicle has a digital display, please switch it on.',
	'fourAdditionalPictures.mileage.enter': 'Enter the vehicle´s mileage',
	'fourAdditionalPictures.mileage.title': 'Mileage',
	'fourAdditionalPictures.overallDashboard.description':
		'Photograph your vehicle´s dashboard completely.',
	'fourAdditionalPictures.overallDashboard.title': 'Vehicle´s dashboard',
	'fourAdditionalPictures.title': 'Additional pictures',
	'fourAdditionalPictures.vin.description':
		'Please take a photo of your vehicle´s VIN number. You could find this on the driver´s door seal or the bottom left corner of the windshield.',
	'fourAdditionalPictures.vin.title': 'Vehicle´s VIN number',
	'fourAdditionalPictures.windshield.description':
		'Please take a detailed photo of your vehicle´s front windshield.',
	'fourAdditionalPictures.windshield.title': 'Vehicle´s front windshield',
	'fourAdditionalPicturesExampleModal.button.close': 'Close',
	'fourAdditionalPicturesExampleModal.headline.first': 'Additional pictures',
	'imageRecognitionMismatchModal.headline': 'Are you sure you added the right photo?',
	'button.backchangeImage': 'Back & change image',
	'review.stepDescription.mileage': 'Mileage',
	'review.headline.first': 'Check',
	'review.paragraph.first':
		'Make sure that all the data is entered, then click "Complete". You will receive a summary of the entered data.',
	'review.stepDescription.vehicleImages': 'Vehicle overview',
	'review.stepDescription.vehicleInformation': 'Vehicle registration',
	'review.stepDescription.fourAdditionalPictures': 'Additional Images',
	'review.editViewButton': 'View / Edit',
	'feedback.headline.policyCheck': 'Thank you for using PolicyCheck!',
	'feedback.description': 'We hope that you are satisfied with our service.',
	'feedback.rating.policyCheck': 'How do you rate the PolicyCheck?',
	'feedback.button.send': 'Send the opinion',
	'feedback.yourOpinion': 'Your opinion',
	'waitForAudit.thankYou': 'Thank you',
	'waitforAudit.finish': 'Finish',
	'waitForAudit.description': 'We will notify you as soon as the pictures are processed.',

	'invalidFile.size.title': 'Incorrect image size',
	'invalidFile.size.description': 'The image size is bigger than the maximum required',
	'invalidFile.extension.title': 'File type is not supported',
	'invalidFile.extension.description':
		'The specified file type is not supported. Supported file types: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp',
};

export default messages;
